export default __webpack_public_path__ + "static/media/IMG-20240708-WA0018.8d1bbf9c.jpg";